var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:({ background: _vm.color })},[_vm._v(_vm._s(_vm.initials))])
}
var staticRenderFns = []

export { render, staticRenderFns }